import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';

import {AppV12} from './AppV12';

const root = document.getElementById('root');

if (!root) {
  throw new Error('Atellius B2B admin root element was not found.');
}

createRoot(root).render(
  <StrictMode>
    <AppV12 />
  </StrictMode>,
);
